// ============================================================
// CHART CONFIG — Configuración centralizada de gráficos
// Tamaños de donut y paletas de colores para todos los dashboards
// ============================================================

// ------------------------------------------------------------
// TAMAÑOS DE DONUT (en px) por breakpoint
// ------------------------------------------------------------
export const DONUT_HEIGHT = {
  desktop:  300,   // > 1500px
  notebook: 300,   // 1024–1500px
  mobile:   180,   // ≤ 768px
};

// Helpers para usar en responsiveConfig de cada TableGraf
export const getDonutHeight = (isNotebook, isMobile) =>
  isNotebook ? DONUT_HEIGHT.notebook : isMobile ? DONUT_HEIGHT.mobile : DONUT_HEIGHT.desktop;

// ------------------------------------------------------------
// PALETA DE BARRAS — compartida por todos los dashboards
// ------------------------------------------------------------
export const BAR_PALETTE = ["#274b72",  "#376596","#0E376E", "#669ece", "#A4C4E0"];


// ------------------------------------------------------------
// PALETAS DE DONUT por módulo
// ------------------------------------------------------------
// Paleta azul anclada en los colores base: #0E376E · #648EBC · #A4C4E0
const P = {
  blue1:  "#071A35",  // extra oscuro
  blue2:  "#0E376E",  // ← base oscuro
  blue3:  "#1A4E8A",
  blue4:  "#2E65A0",
  blue5:  "#4278B4",
  blue6:  "#648EBC",  // ← base medio
  blue7:  "#7EAAD0",
  blue8:  "#92BCE0",
  blue9:  "#A4C4E0",  // ← base claro
  blue10: "#B8D4EA",
  blue11: "#CCE3F2",
  blue12: "#DFF0F9",  // muy claro
  blue13: "#3567A8",  // alternativo medio
};

export const DONUT_COLORS = {
  energy: {
    "Red":                        P.blue1,
    "PPA":                        P.blue2,
    "Solar":                      P.blue3,
    "Gas Natural":                P.blue4,
    "GLP":                        P.blue5,
    "Fuel Oil":                   P.blue6,
    "Carbón":                     P.blue7,
    "Diesel":                     P.blue8,
    "Biodiesel":                  P.blue9,
    "Gasolina":                   P.blue10,
    "Biocombustible":             P.blue11,
    "Biomasa":                    P.blue12,
    "Vapor":                      P.blue13,
  },

  fuels: {
    "Gas Natural":                P.blue2,
    "GLP":                        P.blue4,
    "Diésel":                     P.blue6,
    "Biodiésel":                  P.blue7,
    "Fuel/Gasolina":              P.blue9,
    "Etanol":                     P.blue11,
    "Electricidad para vehículos":P.blue13,
  },

  water: {
    "Agua de red":                P.blue2,
    "Agua subterránea":           P.blue3,
    "Agua de lluvia":             P.blue5,
    "Agua superficial":           P.blue6,
    "Agua destilada":             P.blue7,
    "Agua reutilizada":           P.blue9,
    "Agua reciclada":             P.blue11,
    "Agua condesada de vapor":    P.blue12,
  },

  waterUsage: {
    "Producción":                 P.blue2,
    "Doméstica":                  P.blue6,
    "Combinada":                  P.blue9,
  },

  gei: {
    "Alcance 1 - Emisiones directas":   P.blue2,
    "Alcance 2 - Energía comprada":     P.blue6,
    "Alcance 3 - Emisiones indirectas": P.blue9,
  },

  waste: {
    "Reutilización / Reciclaje":        P.blue2,
    "Compostaje":                       P.blue4,
    "Recuperación Energética":          P.blue6,
    "Incineración sin Recuperación":    P.blue7,
    "Relleno Sanitario":                P.blue9,
    "Otros Métodos":                    P.blue11,
    "Otros":                            P.blue12,
  },

  social: {
    "Mujeres":                    P.blue2,
    "Hombres":                    P.blue6,
    "Otros":                      P.blue9,
  },

  effluent: {
    "domestico":                  P.blue2,
    "industrial":                 P.blue6,
    "combinada":                  P.blue9,
  },

  // Evita blue2/6/9 (son justo los colores de año --chart-year-oldest/
  // prev/last que usan los demás gráficos de comparación por año -- ver
  // más arriba) y separa cada par agua/efluente lo suficiente como para
  // que se distingan entre sí dentro del mismo gráfico (con blue8/blue11
  // quedaban los dos muy claros y parecidos).
  effluentWater: {
    "Consumo Agua Producción":    P.blue1,
    "Efluente Industrial":        P.blue5,
    "Consumo Agua Doméstica":     P.blue3,
    "Efluente Doméstico":         P.blue7,
    "Consumo Agua Combinada":     P.blue4,
    "Efluente Combinado":         P.blue11,
  },
};
